export const api = process.env.REACT_APP_API_URL
	? process.env.REACT_APP_API_URL
	: 'https://brukhue.no/wp-json/brukhue/v1/';

export default {
	api,
};



// WEBPACK FOOTER //
// ./shared/config.js